import { Image as AImage, ImageProps } from "antd";
import { KaceyView } from "../types";
import { useOnMounted } from "./nextutils";

export const Image: KaceyView<ImageProps> = (props) => {
    const mounted = useOnMounted();
    return mounted ? <AImage {...props} /> : <img {...props as any} />
}
